export default class FAQModel {
    constructor(question, answer) {
        this.question = question
        this.answer = answer
        this.open = false
    }
}